import View from '~/app/View'
import PageNav from '~/components/utility-page/page-nav'
import Accordion from '~/components/utility-page/accordion'
import ContactForm from '~/components/utility-page/contact-form'

import '@/templates/page.faq.scss'

const faqsView = new View()
faqsView.init({
  // PageHeader,
  PageNav,
  Accordion,
  ContactForm,
})
